<app-table-loading-overlay></app-table-loading-overlay>
<div class="flex items-center justify-between gap-3 pb-2">

  <div class="flex items-center gap-2">
    <div #title class="font-bold uppercase text-surface-900" style="font-size: 18px;">
      {{ widgetHeader() }}
    </div>

    <!-- Status dot 
    <span class="inline-block h-2.5 w-2.5 rounded-full" [ngClass]="vm().dotClass" aria-hidden="true"></span>-->

    <!-- PrimeNG Tag -->
    <!--<p-tag
          [value]="vm().label"
          [severity]="vm().severity"
          styleClass="text-xs"
        ></p-tag>-->
  </div>

  <div class="flex items-center gap-2 text-sm text-surface-500">
    <i class="pi pi-clock"></i>
    <span *ngIf="lastUpdated(); else never">
      {{ lastUpdated() | date: 'dd.MM.yyyy HH:mm' }}
    </span>
    <ng-template #never>noch nie</ng-template>
    <!-- <p-button
        label="Aktualisieren"
        icon="pi pi-refresh"
        size="small"
        styleClass="p-button-sm"
        (onClick)="refresh()"
      ></p-button>-->
  </div>

</div>

<div class="space-y-3 pt-1">
  <div class="flex flex-row items-center">
    <h2 class="mr-2">Status: </h2>

    <p-tag [value]="vm().label" [severity]="vm().severity" styleClass="text-xs"></p-tag>
  </div>
  <!-- Message 
    <div >
      <h2 class="font-bold pb-3">Störungsmeldungen</h2>

      <div class="text-sm leading-snug">
        <ng-container *ngIf="vm().message; else noMsg">
         <div class="whitespace-pre-line">{{ vm().message }}</div>
        </ng-container>
        <ng-template #noMsg>
          <span class="text-surface-500">Keine weiteren Informationen.</span>
        </ng-template>
      </div>
    </div>-->


</div>